import _get from 'lodash/get';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import { actionShowWireFileDialog } from './dialogs/wireFileDialog';

import { API_WIRE_SETTINGS_NOT_FOUND_ERROR } from '../constants/errors';

import { defaultWire } from '../reducer';

import {
  ACTION_LOAD_WIRE__REQUEST,
  ACTION_LOAD_WIRE__SUCCESS,
  ACTION_LOAD_WIRE__FAIL,

  ACTION_EDIT_WIRE__REQUEST,
  ACTION_EDIT_WIRE__SUCCESS,
  ACTION_EDIT_WIRE__FAIL,

  ACTION_CANCEL_WIRE__REQUEST,
  ACTION_CANCEL_WIRE__SUCCESS,
  ACTION_CANCEL_WIRE__FAIL,

  ACTION_LOAD_WIRE_FILE__REQUEST,
  ACTION_LOAD_WIRE_FILE__SUCCESS,
  ACTION_LOAD_WIRE_FILE__FAIL,
} from '../actionTypes';

import { file } from 'react-redux-app/lib/modules/core/utils';


const actionLoadWireSuccess = wire => ({
  type: ACTION_LOAD_WIRE__SUCCESS,
  payload: { wire },
});

const actionLoadWireFail = error => ({
  type: ACTION_LOAD_WIRE__FAIL,
  payload: { error },
});

export const actionLoadWireRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_WIRE__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/wire'
    ).then(
      result => {
        dispatch(actionLoadWireSuccess(result));
      },
      error => {
        const errorCode = _get(error, 'globalErrors[0].code');
        if (errorCode === API_WIRE_SETTINGS_NOT_FOUND_ERROR) {
          dispatch(actionLoadWireSuccess(defaultWire));
        } else {
          dispatch(actionLoadWireFail(error));
        }
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionEditWireSuccess = wire => ({
  type: ACTION_EDIT_WIRE__SUCCESS,
  payload: { wire },
});

const actionEditWireFail = error => ({
  type: ACTION_EDIT_WIRE__FAIL,
  payload: { error },
});

export const actionEditWireRequest = wireFields => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_EDIT_WIRE__REQUEST,
    });

    const formData = new FormData();
    Object.keys(wireFields).forEach(key => {
      formData.append(key, wireFields[key]);
    });

    return apiClientHelper.post(
      '/rest/webmaster/wire',
      { data: formData, file: true }
    ).then(
      result => {
        dispatch(actionEditWireSuccess(result));
      },
      error => {
        dispatch(actionEditWireFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionCancelWireSuccess = () => ({
  type: ACTION_CANCEL_WIRE__SUCCESS,
});

const actionCancelWireFail = error => ({
  type: ACTION_CANCEL_WIRE__FAIL,
  payload: { error },
});

export const actionCancelWireRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_CANCEL_WIRE__REQUEST,
    });

    return apiClientHelper.post(
      '/rest/webmaster/wire/cancel_pending'
    ).then(
      () => {
        dispatch(actionCancelWireSuccess());
      },
      error => {
        dispatch(actionCancelWireFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);


const actionLoadWireFileSuccess = () => ({
  type: ACTION_LOAD_WIRE_FILE__SUCCESS,
});

const actionLoadWireFileFail = error => ({
  type: ACTION_LOAD_WIRE_FILE__FAIL,
  payload: { error },
});

export const actionLoadWireFileRequest = wireId => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_WIRE_FILE__REQUEST,
    });

    return apiClientHelper.get(
      `/rest/webmaster/wire/file/${wireId}`,
      { blobResponse: true }
    ).then(
      f => {
        dispatch(actionLoadWireFileSuccess());

        if (file.getIsPdf(f)) {
          file.saveFile(f, 'bank-account.pdf');
        } else {
          const reader = new FileReader();
          reader.onload = () => {
            dispatch(actionShowWireFileDialog(reader.result));
          };
          reader.readAsDataURL(f);
        }
      },
      error => {
        dispatch(actionLoadWireFileFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
